import React, { useState } from 'react';
import { AuditLog } from '../types';
import { FilterIcon, TerminalIcon } from 'lucide-react';
interface AuditLogPageProps {
  logs: AuditLog[];
}
export function AuditLogPage({
  logs
}: AuditLogPageProps) {
  const [userFilter, setUserFilter] = useState('Semua User');
  const [actionFilter, setActionFilter] = useState('Semua Aksi');
  const uniqueUsers = ['Semua User', ...Array.from(new Set(logs.map(l => l.userName)))];
  const uniqueActions = ['Semua Aksi', ...Array.from(new Set(logs.map(l => l.action)))];
  const filteredLogs = logs.filter(log => {
    const matchUser = userFilter === 'Semua User' || log.userName === userFilter;
    const matchAction = actionFilter === 'Semua Aksi' || log.action === actionFilter;
    return matchUser && matchAction;
  }).sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  const inputClasses = 'border border-[#1E3A5F] rounded text-sm py-2 px-3 focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0] min-w-[150px]';
  const labelClasses = 'block text-xs font-semibold text-[#94A3B8] mb-1.5';
  return <div className="space-y-6" data-id="element-452">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-453">
        <h2 className="text-2xl font-bold text-[#E2E8F0] uppercase tracking-wide flex items-center" data-id="element-454">
          <TerminalIcon className="w-6 h-6 mr-3 text-[#00D4FF]" data-id="element-455" />
          SYSTEM AUDIT LOG
        </h2>
      </div>

      <div className="bg-[#111827] p-4 rounded shadow-lg border border-[#1E3A5F] flex flex-wrap gap-4 items-end" data-id="element-456">
        <div data-id="element-457">
          <label className={labelClasses} data-id="element-458">User ID</label>
          <select className={inputClasses} value={userFilter} onChange={e => setUserFilter(e.target.value)} data-id="element-459">
            {uniqueUsers.map(u => <option key={u} value={u} data-id="element-460">
                {u}
              </option>)}
          </select>
        </div>
        <div data-id="element-461">
          <label className={labelClasses} data-id="element-462">Tipe Aksi</label>
          <select className={inputClasses} value={actionFilter} onChange={e => setActionFilter(e.target.value)} data-id="element-463">
            {uniqueActions.map(a => <option key={a} value={a} data-id="element-464">
                {a}
              </option>)}
          </select>
        </div>
        <div data-id="element-465">
          <label className={labelClasses} data-id="element-466">Timestamp Mulai</label>
          <input type="date" className={`${inputClasses} font-mono`} data-id="element-467" />
        </div>
        <div data-id="element-468">
          <label className={labelClasses} data-id="element-469">Timestamp Akhir</label>
          <input type="date" className={`${inputClasses} font-mono`} data-id="element-470" />
        </div>
        <button className="px-4 py-2 bg-[#1A2332] border border-[#1E3A5F] text-[#E2E8F0] rounded hover:bg-[#1E3A5F] text-xs font-bold uppercase flex items-center h-[38px] transition-colors" data-id="element-471">
          <FilterIcon className="w-4 h-4 mr-2 text-[#00D4FF]" data-id="element-472" /> EXECUTE QUERY
        </button>
      </div>

      <div className="bg-[#0B0F1A] rounded shadow-lg border border-[#1E3A5F] overflow-hidden relative" data-id="element-473">
        <div className="absolute inset-0 scanline opacity-10 pointer-events-none" data-id="element-474"></div>
        <div className="overflow-x-auto relative z-10" data-id="element-475">
          <table className="w-full text-sm text-left" data-id="element-476">
            <thead className="text-xs text-[#00D4FF]/70 uppercase bg-[#070A12] border-b border-[#1E3A5F] font-mono" data-id="element-477">
              <tr data-id="element-478">
                <th className="px-4 py-3 font-semibold w-12 text-center" data-id="element-479">
                  SEQ
                </th>
                <th className="px-4 py-3 font-semibold" data-id="element-480">TIMESTAMP</th>
                <th className="px-4 py-3 font-semibold" data-id="element-481">USER_IDENTIFIER</th>
                <th className="px-4 py-3 font-semibold" data-id="element-482">ACTION_TYPE</th>
                <th className="px-4 py-3 font-semibold" data-id="element-483">MODULE</th>
                <th className="px-4 py-3 font-semibold" data-id="element-484">OBJECT_REF</th>
                <th className="px-4 py-3 font-semibold" data-id="element-485">SOURCE_IP</th>
              </tr>
            </thead>
            <tbody className="font-mono text-xs" data-id="element-486">
              {filteredLogs.length > 0 ? filteredLogs.map((log, index) => <tr key={log.id} className="border-b border-[#1E3A5F]/30 hover:bg-[#111827] transition-colors" data-id="element-487">
                    <td className="px-4 py-3 text-center text-[#64748B]" data-id="element-488">
                      {(filteredLogs.length - index).toString().padStart(4, '0')}
                    </td>
                    <td className="px-4 py-3 text-[#64748B]" data-id="element-489">
                      {new Date(log.createdAt).toISOString().replace('T', ' ').substring(0, 19)}
                    </td>
                    <td className="px-4 py-3 text-[#E2E8F0]" data-id="element-490">
                      {log.userName}{' '}
                      <span className="text-[#475569]" data-id="element-491">[{log.userId}]</span>
                    </td>
                    <td className="px-4 py-3" data-id="element-492">
                      <span className="bg-[#00D4FF]/10 text-[#00D4FF] px-2 py-0.5 rounded text-xs uppercase border border-[#00D4FF]/20" data-id="element-493">
                        {log.action}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-[#94A3B8] uppercase" data-id="element-494">
                      {log.module}
                    </td>
                    <td className="px-4 py-3 text-[#FFB800]" data-id="element-495">{log.objectId}</td>
                    <td className="px-4 py-3 text-[#00FF88]" data-id="element-496">
                      {log.ipAddress}
                    </td>
                  </tr>) : <tr data-id="element-497">
                  <td colSpan={7} className="px-4 py-8 text-center text-[#64748B] font-sans" data-id="element-498">
                    Tidak ada log audit yang sesuai dengan filter.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}